import {Module} from '@dms/api/shared';
import {moduleKeys} from '@dms/config';
import {businessCaseRoutes} from '@dms/routes';
import {permissions} from '@dms/shared';

import {BusinessCaseDetailWrapper} from './pages/BusinessCaseDetail/BusinessCaseDetail';
import {BusinessCases} from './pages/BusinessCases/BusinessCases';
import {CreateBusinessCase} from './pages/CreateBusinessCase/CreateBusinessCase';

export const BusinessCaseModule: Module = {
  id: moduleKeys.businessCase,
  layoutProps: {
    icon: 'sidebar/business_case',
    title: 'page.businessCases.title',
  },
  routerProps: {
    path: businessCaseRoutes.home,
    element: <BusinessCases />,
  },
  requiredPermission: permissions.businessCaseRead,
  requiredPermissionAtLeastOne: [
    permissions.viewBusinessCasePurchase,
    permissions.viewBusinessCaseSelling,
  ],
  content: [
    {
      id: 'business-cases-list',
      routerProps: {
        path: businessCaseRoutes.home,
        element: <BusinessCases />,
      },
      layoutProps: {
        title: 'page.businessCases.title',
        icon: 'sidebar/business_case',
      },
    },
    {
      id: 'business-cases-list-openSearch',
      routerProps: {
        path: businessCaseRoutes.openSearch,
        element: <BusinessCases />,
      },
    },
    {
      id: 'business-cases-complaints-list',
      routerProps: {
        path: businessCaseRoutes.complaintsList,
        element: <BusinessCases />,
      },
      requiredPermission: permissions.complaintRead,
    },
    {
      id: 'business-cases-detail',
      routerProps: {
        paths: [
          businessCaseRoutes.overview,
          businessCaseRoutes.checklists,
          businessCaseRoutes.customer,
          businessCaseRoutes.buying,
          businessCaseRoutes.selling,
          businessCaseRoutes.testDrive,
          businessCaseRoutes.reservations,
          businessCaseRoutes.insurance,
          businessCaseRoutes.checkout,
          businessCaseRoutes.documents,
          businessCaseRoutes.serviceCases,
          businessCaseRoutes.activityLog,
          businessCaseRoutes.emailActivityLogs,
          businessCaseRoutes.tasks,
        ],
        element: <BusinessCaseDetailWrapper />,
      },
    },
    {
      id: 'business-case-complaints',
      routerProps: {
        path: businessCaseRoutes.complaints,
        element: <BusinessCaseDetailWrapper />,
      },
      requiredPermission: permissions.complaintRead,
    },
    {
      id: 'business-cases-concept',
      routerProps: {
        path: businessCaseRoutes.concept,
        element: <CreateBusinessCase />,
      },
      layoutProps: {
        isPartOfCreateMenuItem: true,
        title: 'entity.businessCase.actions.addBusinessCase',
      },
      requiredPermission: permissions.businessCaseRead,
    },
  ],
};
